var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2006",
    "data-name": "Group 2006",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0.645 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_person_light",
    "data-name": "UI icon/person/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_132_Stroke_",
    "data-name": "Ellipse 132 (Stroke)",
    d: "M3,6A3,3,0,1,1,6,3,3,3,0,0,1,3,6ZM3,1.2A1.8,1.8,0,1,0,4.8,3,1.8,1.8,0,0,0,3,1.2Z",
    transform: "translate(2.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631_Stroke_",
    "data-name": "Vector 631 (Stroke)",
    d: "M3.453,1.151a2.3,2.3,0,0,0-2.3,2.3v.575A.575.575,0,1,1,0,4.028V3.453A3.453,3.453,0,0,1,3.453,0H6.905a3.453,3.453,0,0,1,3.453,3.453v.575a.575.575,0,1,1-1.151,0V3.453a2.3,2.3,0,0,0-2.3-2.3Z",
    transform: "translate(0 6.608)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_person_light-2",
    "data-name": "UI icon/person/light",
    transform: "translate(8.355 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_132_Stroke_2",
    "data-name": "Ellipse 132 (Stroke)",
    d: "M3,6A3,3,0,1,1,6,3,3,3,0,0,1,3,6ZM3,1.2A1.8,1.8,0,1,0,4.8,3,1.8,1.8,0,0,0,3,1.2Z",
    transform: "translate(2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631_Stroke_2",
    "data-name": "Vector 631 (Stroke)",
    d: "M3.453,1.151a2.3,2.3,0,0,0-2.3,2.3v.575A.575.575,0,1,1,0,4.028V3.453A3.453,3.453,0,0,1,3.453,0H6.905a3.453,3.453,0,0,1,3.453,3.453v.575a.575.575,0,1,1-1.151,0V3.453a2.3,2.3,0,0,0-2.3-2.3Z",
    transform: "translate(0 6.906)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8238b2fd1ad7fac6f0de967524dd39e2.svg";
export { ForwardRef as ReactComponent };